import React, {Component} from 'react'
import NoteColumnPopup from './NoteColumnPopup'
import PropTypes from 'prop-types'

class NoteColumn extends Component {
    state = {
        showFull: false,
        isOpen: false,
    }

    _handleTogglePopup = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    _handleToggleFull = () => {
        this.setState({
            showFull: !this.state.showFull
        })
    }

    render() {
        const {isOpen, showFull} = this.state
        const {id, note} = this.props

        return <td className="Note">
            {showFull ? note : note.length > 50 ? <span>{note.substr(0, 50)} <span onClick={this._handleToggleFull}
                                                                                   className="text-primary font-weight-bold cursor-pointer">...</span></span> : note}
            <i className="icon-pencil text-success mt-1 d-flex" onClick={this._handleTogglePopup}/>
            {isOpen && <NoteColumnPopup id={id} note={note} onTogglePopup={this._handleTogglePopup} isOpen={isOpen}/>}
        </td>
    }
}

NoteColumn.propTypes = {
    id: PropTypes.string.isRequired,
    note: PropTypes.string
}

export default NoteColumn